export default "__VITE_ASSET__9471448a__"